import { useEffect, useState } from "react";

export const useFetch = (
  fetcher,
  configs = {
    dependencies: [],
  }
) => {
  const { dependencies = [], resolver } = configs;
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  async function fetchData() {
    try {
      setError(null);
      const result = await fetcher();
      setData(resolver ? resolver(result.data) : result.data);
    } catch (error) {
      setError(error);
    }
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, dependencies);

  return [data, error];
};
